/**
 * Soft-link parking spots to units:
 * - By default, spots follow units (1:1) when units change.
 * - A manual spots edit sets parkingSpotsManual so the override sticks
 *   across further unit changes and survives save/load.
 * - Legacy deals without the flag: treat as linked only when values match.
 */

export function shouldParkingSpotsFollowUnits(inputs) {
  if (inputs.parkingSpotsManual === true) return false;
  if (inputs.parkingSpotsManual === false) return true;
  return Number(inputs.numberOfParkingSpots) === Number(inputs.numberOfUnits);
}

export function applyUnitsChange(inputs, numberOfUnits) {
  const next = { ...inputs, numberOfUnits };
  if (shouldParkingSpotsFollowUnits(inputs) && numberOfUnits > 0) {
    next.numberOfParkingSpots = numberOfUnits;
  }
  return next;
}

export function applyParkingSpotsChange(inputs, numberOfParkingSpots) {
  return {
    ...inputs,
    numberOfParkingSpots,
    parkingSpotsManual: numberOfParkingSpots !== Number(inputs.numberOfUnits),
  };
}
